import type { TourSection } from './types';

export const aiConfigsDetailSections: TourSection[] = [
  {
    id: 'attribute-name',
    label: 'Atributo a generar',
    steps: [
      {
        target: '[data-tour="ai-config-attribute"]',
        title: 'Qué atributo va a generar la IA',
        content:
          'El campo del producto que la IA va a llenar (ej: descripción larga, especificaciones). Solo aparecen campos que se pueden modificar.',
      },
    ],
  },
  {
    id: 'category',
    label: 'Categoría',
    steps: [
      {
        target: '[data-tour="ai-config-category"]',
        title: 'A qué productos aplica',
        content:
          'Categoría a la que aplica esta configuración. Vacío = aplica a todas (configuración global, menor prioridad). Si eliges una categoría específica, gana sobre la global cuando un producto cae en esa categoría.',
      },
    ],
  },
  {
    id: 'model',
    label: 'Modelo de IA',
    steps: [
      {
        target: '[data-tour="ai-config-model"]',
        title: 'Modelo a usar',
        content:
          'Qué inteligencia artificial procesa la instrucción (Gemini, Claude). Cada modelo tiene su costo y velocidad — puedes revisar el historial en Sugerencias IA para comparar.',
      },
    ],
  },
  {
    id: 'prompt',
    label: 'Instrucción',
    steps: [
      {
        target: '[data-tour="ai-config-prompt"]',
        title: 'Instrucción para la IA',
        content:
          'El texto que se le manda al modelo. Puedes insertar variables del producto entre llaves: {productName}, {attributes}, etc. La calidad de la sugerencia depende mucho de la claridad de esta instrucción.',
      },
    ],
  },
  {
    id: 'product-fields',
    label: 'Datos del producto que lee la IA',
    steps: [
      {
        target: '[data-tour="ai-config-product-fields"]',
        title: 'Campos de contexto',
        content:
          'Qué campos del producto le pasa al modelo como contexto para que genere una sugerencia mejor. A más campos, más información tiene la IA pero más caro sale.',
      },
    ],
  },
  {
    id: 'field-priority',
    label: 'Prioridad de fuentes',
    steps: [
      {
        target: '[data-tour="ai-config-field-priority"]',
        title: 'De qué fuente lee cada dato',
        content:
          'Si un dato del producto está en varias fuentes (ej: nombre en vtex y en sap), defines cuál usar primero. Por ejemplo: para el nombre priorizar vtex sobre sap.',
      },
    ],
  },
  {
    id: 'schema-override',
    label: 'Reglas de validación',
    steps: [
      {
        target: '[data-tour="ai-config-schema-override"]',
        title: 'Reglas extra para esta categoría',
        content:
          'Reglas adicionales que el valor generado debe cumplir (ej: valores permitidos, largo máximo) solo para esta categoría. Si no configuras nada, se aplican las reglas generales del campo.',
      },
    ],
  },
  {
    id: 'active-toggle',
    label: 'Activar / desactivar',
    steps: [
      {
        target: '[data-tour="ai-config-active"]',
        title: 'Activa',
        content:
          'Si está desactivada, el botón de generar con IA desaparece de los productos de esa categoría. Sirve para "pausar" una configuración mientras ajustas la instrucción sin tener que borrarla.',
      },
    ],
  },
];
